import React from 'react';
import { Sparkles } from 'lucide-react';
import AgentLanding from '../agents/shared/AgentLanding';
import { dataContentProfilerSpec } from './spec';

const DataContentProfilerPage: React.FC = () => {
  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-cargo-text flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-cargo-accent" />
          Data Content Profiler
        </h1>
        <p className="text-cargo-muted mt-1">
          Profile a table's content in chat — what each column contains plus data-quality observations
        </p>
      </div>
      <AgentLanding spec={dataContentProfilerSpec} />
    </div>
  );
};

export default DataContentProfilerPage;
